import { useEffect, useState } from "react";
import { useAppSelector } from "state/hooks";
import { getGroupState } from "state/slices/group-slice";
import { getPartnerGamesPath } from "utils/backend-path-builders";
import { getRequest } from "utils/httpClient";
import PartnerGamePresenter from "./presenter";

const PartnerGameCarousel = () => {
  const groupId = useAppSelector(getGroupState).id;
  const [games, setGames] = useState([]);

  useEffect(() => {
    const path = getPartnerGamesPath(groupId);

    getRequest(path)
      .then((data) => {
        setGames(data || []);
      })
      .catch((error) => {
        console.error("Error fetching partner games:", error);
      });
  }, []);

  return (
    <div>
      <PartnerGamePresenter games={games} />
    </div>
  );
};

export default PartnerGameCarousel;
